const siteCode = '97oivf4dlf'

export default siteCode